import React, { useRef, useEffect, useState } from 'react';
//import { ReactComponent as EspoBuildLogo } from '../assets/espobuild-o.svg';
import EspoBuiltLogo from '../web_elements/espobuilt_logo_500.png';
import BlueDecorativeStripe from '../web_elements/decorative_stripe_full.png';
import "../styles/EspoBuiltHeader.css";
import { ReactComponent as DecorationHeader } from '../web_elements/decoration1-o.svg';
//import { ReactComponent as PhoneButtonSVG} from "../assets/PhoneBtn.svg";
import ChatIcon from '../web_elements/chat_icon_48.png';
import PhoneIcon from '../web_elements/icons8-phone-100.png';
import ChatOverlay from "./ChatOverlay";
import {AnimatePresence} from "framer-motion";

const EspoBuiltHeader = () => {
    const logoRef = useRef(null);
    const [paddingTop, setPaddingTop] = useState();
    const [toggleChatOverlay, setToggleChatOverlay] = useState(false);
    useEffect(() => {
        if (logoRef.current) {
            setTimeout(() => {
                const logoHeight = logoRef.current.getBoundingClientRect().height;
                //console.log("Logo height:", logoHeight);
                setPaddingTop(logoHeight * 1.2); // 120% of the logo's height
            }, 0); // Minimal delay to ensure DOM readiness
        }
    }, []);
    return (
        <div className="EspoBuiltHeader-component">
            <div id='navbar'>
                <a href="tel:+359876452875">
                    <img className="header-icon"
                         src={PhoneIcon}
                         alt="ChatIcon"
                    >
                    </img>
                </a>

                <img className="EspoBuilt-logo"
                     ref={logoRef}
                     src={EspoBuiltLogo}
                     alt="">

                </img>
                <img
                    className="header-icon"
                    src={ChatIcon}
                    alt="ChatIcon"
                    onClick={() => setToggleChatOverlay(v => !v)}
                >
                </img>
            </div>
            <DecorationHeader className="BlueDecorativeStripe"
                              style={{
                                  maxWidth: '100%', //global is 90%
                              }}
            />
            <AnimatePresence>
             {toggleChatOverlay && <ChatOverlay />}
            </AnimatePresence>
        </div>
    )
}
export default EspoBuiltHeader;